module.exports = __webpack_public_path__ + "img/reezocar-logo-1@2x.a65332ab.png";